import { skipToken, useQuery } from "@tanstack/react-query";
import { getLicensesPublicPartyID } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";
import { MS_TIME } from "Utils/TimeUtils";

const PARTY_LICENSE_QUERY_KEY = "PARTY_LICENSE";

export const partyLicensesKeys = {
  all: [PARTY_LICENSE_QUERY_KEY],
  byPartyPublicId: (partyPublicID?: string) => [
    ...partyLicensesKeys.all,
    partyPublicID,
  ],
};

type Options = {
  staleTime?: number;
  refetchInterval?: number;
};

export const usePartyLicensesQuery = (
  partyPublicID?: string,
  options?: Options,
) =>
  useQuery({
    queryKey: partyLicensesKeys.byPartyPublicId(partyPublicID),
    queryFn: partyPublicID
      ? processResponseWithApiProblemDetails(() =>
          getLicensesPublicPartyID(partyPublicID),
        )
      : skipToken,
    refetchOnWindowFocus: false,
    staleTime: options?.staleTime ?? MS_TIME.hour,
    refetchInterval: options?.refetchInterval,
  });
